import React, { useState } from 'react'
import AgreementButton from './AgreementButton'
import AddAgreement from './Mdoals/AddAgreement'
import AppAgreementsModal from './Mdoals/AppAgreements'
import { AgreementResp } from 'types/agreement/agreement'

const AppAgreement: React.FC = () => {
  const [agreementModal, setAgreementModal] = useState<boolean>(false)
  const [addAgreementModal, setAddAgreementModal] = useState<boolean>(false)
  const [forApp, setForApp] = useState<string>()
  const [selectedAgreement, setSelectedAgreement] = useState<AgreementResp>()

  const handleAddAgreementModal = (
    app: 'guardian' | 'mentor' | 'organizer' | undefined,
  ) => {
    setAgreementModal(true)
    setForApp(app)
  }

  console.log(forApp, agreementModal, 'abcd')

  return (
    <>
      <div className="flex flex-col gap-16px">
        <AgreementButton
          text={'For Family'}
          openModal={handleAddAgreementModal}
        />
        <AgreementButton
          text={'For Mentors'}
          openModal={handleAddAgreementModal}
        />
        <AgreementButton
          text={'For Organizers'}
          openModal={handleAddAgreementModal}
        />
      </div>

      {addAgreementModal && (
        <AddAgreement
          openModal={addAgreementModal}
          setOpenModal={setAddAgreementModal}
          forApp={forApp as 'guardian' | 'mentor' | 'organizer'}
          setForApp={setForApp}
          selectedAgreement={selectedAgreement}
          setSelectedAgreement={setSelectedAgreement}
        />
      )}

      {agreementModal && (
        <AppAgreementsModal
          openModal={agreementModal}
          setOpenModal={setAgreementModal}
          forApp={forApp as 'guardian' | 'mentor' | 'organizer'}
          setForApp={setForApp}
          setAddAgreementModal={setAddAgreementModal}
          setSelectedAgreement={setSelectedAgreement}
        />
      )}
    </>
  )
}

export default AppAgreement
